import doc                  from '@widesk-core/decorators/doc';
import model                from '@widesk-core/decorators/model';
import AccountServiceModel  from '@/models/AccountServiceModel';
import TimestampAble        from '@widesk-core/models/traits/TimestampAble';
import Blamable             from '@/models/traits/Blamable';

@model.urnResource('functionality_type')
@doc.path('/functionality_types/{?id}')
export default class FunctionalityTypeModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'id': id;
		'reference': string;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};	

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
}